module.exports = __webpack_public_path__ + "img/default.60a5503d.jpg";